import { Controller } from "@hotwired/stimulus"

// Asks before a destructive click goes through: put it on the button with
// data-action="confirm#ask" and the question in data-confirm-message-value.
// Cancelling stops the click, so a submit button never submits and any later
// action on the same element (e.g. split-menu#choose) doesn't run.
//
// This replaces onclick="return confirm(...)", which the enforcing CSP blocks,
// so the button used to submit without asking. data-turbo-confirm is no
// substitute on a form with data-turbo="false": Turbo never sees that submit.
export default class extends Controller {
    static values = { message: String }

    ask(event) {
        if (window.confirm(this.messageValue || "Are you sure?")) return
        event.preventDefault()
        event.stopImmediatePropagation()
    }
}
